import React from 'react';
import PropTypes from 'prop-types';

const Icon = ({icon}) => (
  <div className={`halflings halflings-${icon}`}></div>
);

Icon.propTypes = {
  icon: PropTypes.string.isRequired
};

export default Icon;
